import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { AppApiService } from './app-api.service';

@Injectable({
  providedIn: 'root',
})
export class CommunicationsApiService {
  protected baseEndpoint = environment.communications.host + '/gateway/widget/omnichannel/v2/';

  constructor(protected api: AppApiService) {}
}
